import type { FileUploadedAcknowledgedResult } from "@/services/abstract/poc/messaging.service.interface";
import type { HeliaNode } from "@/types/poc/helia";
import type { LibP2pWithServices } from "@/types/poc/libp2p";
import type { MessageHandler, MessagePayload } from "@/types/poc/message";
import { createLogger, type Logger } from "@/utils/logger";

const log: Logger = createLogger({ namespace: 'six3ro:p2p:handlers:file-ready-for-download-acknowledged' });

export const createFileUploadedAcknowledgedHandler = (): MessageHandler<FileUploadedAcknowledgedResult> => ({
  canHandle: (_topic: string, message: MessagePayload): boolean =>
    message.type === 'file-ready-for-download-acknowledged',

  process: (
    message: MessagePayload,
    _libp2p: LibP2pWithServices,
    _heliaNode: HeliaNode | null
  ): FileUploadedAcknowledgedResult => {
    if (message.type !== 'file-ready-for-download-acknowledged') {
      throw new Error(`Invalid message type: expected 'file-ready-for-download-acknowledged', got '${message.type}'`);
    }

    const { messageId, sender, timestamp } = message;
    log.info('Received file-ready-for-download-acknowledged for message:', messageId, 'from', sender);

    return {
      messageId,
      sender,
      messageTimestamp: timestamp
    };
  }
});
